import React from 'react';

import {
  ProfilFourriereViolationDtoFormFieldEnum,
  ReferenceDtoAutoriteFourriereDto,
} from 'lib_api/lib/api/gen';

import { Select } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import {
  FicheProfilFourriereBlocFourriere,
  InputPropFourriere,
} from 'types/FicheProfil/FicheProfilGardienFourriere';
import { CSSUtils } from 'utils/CSSUtils';
import { formatAutoriteFourriereDto } from 'utils/dtoToString';

import { validateFicheProfilGf } from '../../utils';

type SelectAttachmentAuthorityProps = InputPropFourriere & {
  refAutoriteFourriere: ReferenceDtoAutoriteFourriereDto;
};

function SelectAttachmentAuthority({
  values,
  isEditable,
  generateRequestDto,
  refAutoriteFourriere,
}: SelectAttachmentAuthorityProps): React.ReactElement {
  const user = useUserStore();
  const gfController = useApi().GardienFourriereControllerApi;
  const key: keyof FicheProfilFourriereBlocFourriere = 'attachmentAuthority';
  const label = 'Autorité de fourrière de rattachement';
  const selectItems = refAutoriteFourriere.referenceDtoList
    .sort(
      (a, b) =>
        a.ville.localeCompare(b.ville) ||
        a.type.type.localeCompare(b.type.type),
    )
    .map(autoriteFourriere => ({
      value: autoriteFourriere.id,
      displayValue: formatAutoriteFourriereDto(autoriteFourriere),
    }));

  return (
    <Select
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: label,
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: string[] | undefined,
              ): Promise<void> => {
                return validateFicheProfilGf(
                  gfController,
                  ProfilFourriereViolationDtoFormFieldEnum.AUTORITES_FOURRIERE_IDS,
                  user.idCorrelationFourriere || '',
                  generateRequestDto({ ...values, [key]: value }),
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
        editable: isEditable,
      }}
      optionProps={selectItems}
      selectProps={{
        mode: 'multiple',
        placeholder: FormPlaceholders.Select,
        dropdownMatchSelectWidth: 350,
      }}
    />
  );
}

export default SelectAttachmentAuthority;
